<template>
  <div id="user">
    <p class="title"><label @click="$router.push('/user/home')">我的 / </label>子用户管理</p>
    <div class="common-search-box">
      <div>
        <div>
          <span>用户名称</span>
          <el-input v-model="query.name" size="small" />
        </div>
        <div>
          <span>联系人</span>
          <el-input v-model="query.linkman" size="small" />
        </div>
        <div>
          <span>联系电话</span>
          <el-input v-model="query.telphone" size="small" />
        </div>
        <div>
          <span>账号</span>
          <el-input v-model="query.username" size="small" />
        </div>
      </div>
      <button class="common-btn" @click="add">添加子用户</button>
    </div>
    <div class="table">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="username" label="用户名称"></el-table-column>
        <el-table-column prop="linkman" label="联系人"></el-table-column>
        <el-table-column prop="telphone" label="联系电话"></el-table-column>
        <el-table-column prop="userStatus" label="状态">
          <template slot-scope="scope">
            <span>{{scope.row.userStatus == 1 ? "启用":"禁用"}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="username" label="账号" width="160"></el-table-column> -->
        <el-table-column prop="id" label="操作" align="center" width="280">
          <template slot-scope="scope">
            <button class="common-btn-text" @click="edit(scope.row)">编辑</button>
            <el-popconfirm title="确认删除？" @confirm="del(scope.row)">
              <button class="common-btn-text" slot="reference">删除</button>
            </el-popconfirm>
            <el-popconfirm
              :title="`确认${scope.row.userStatus == 1 ? '禁用':'启用'}？`"
              @confirm="frozen(scope.row)"
            >
              <button
                class="common-btn-text"
                slot="reference"
              >{{scope.row.userStatus == 1 ? "禁用":"启用"}}</button>
            </el-popconfirm>
            <el-popconfirm title="确认重置密码？" @confirm="resetPassword(scope.row)">
              <button class="common-btn-text common-btn-text-1" slot="reference">重置密码</button>
            </el-popconfirm>
            <!-- <button class="common-btn-text" @click="changeED(scope.row)">授信额度分配</button> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="query.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog class="address-modal" title="添加子用户" :visible.sync="addModal" width="600px">
      <el-form :model="form" ref="form" :rules="rules">
        <el-form-item label="用户名" :label-width="labelWidth" prop="username">
          <el-input v-model="form.username"></el-input>
        </el-form-item>
        <el-form-item v-if="!this.isEdit" label="设置密码" :label-width="labelWidth" prop="password">
          <el-input type="password" v-model="form.password"></el-input>
        </el-form-item>
        <el-form-item v-if="!this.isEdit" label="确认密码" :label-width="labelWidth" prop="repwd">
          <el-input type="repwd" v-model="form.repwd"></el-input>
        </el-form-item>
        <el-form-item label="联系人" :label-width="labelWidth">
          <el-input maxlength="11" v-model="form.linkman"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" :label-width="labelWidth" prop="telphone">
          <el-input maxlength="11" v-model="form.telphone"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addModal = false">取 消</el-button>
        <el-button type="primary" @click="userAdd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  userAdd,
  checkTelphone,
  checkUsername,
  queryChildren,
  userEdit,
  userDelete,
  resetPassword,
  frozen,
  beforehandLimit
} from "@/js/api";
export default {
  name: "orderlist",
  computed: {},
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.form.repwd !== "") {
          this.$refs.form.validateField("repwd");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var checkTel = (rule, value, callback) => {
      if (this.isEdit) return callback();
      checkTelphone({
        telphone: value
      }).then(res => {
        if (res.code == 0) {
          callback();
        } else {
          callback(new Error("手机号已注册"));
        }
      });
    };
    var checkName = (rule, value, callback) => {
      if (this.isEdit) return callback();
      checkUsername({
        username: value
      }).then(res => {
        if (res.code == 0) {
          callback();
        } else {
          callback(new Error("账户名已注册"));
        }
      });
    };
    return {
      query: {
        page: 0,
        pageSize: 10,
        orderStatus: this.$route.query.orderStatus || "",
        createTime: "",
        endTime: "",
        searchTime: []
      },
      total: 0,
      labelWidth: "120px",
      addModal: false,
      tableData: [],
      form: {
        parentId: this.$store.state.user.info.id,
        userType: 2,
        username: "",
        password: "",
        repwd: ""
      },
      rules: {
        username: [
          { required: true, message: "请输入账号名", trigger: "blur" },
          { min: 5, message: "长度在 5 个字符以上", trigger: "blur" },
          { validator: checkName, trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" }
        ],
        repwd: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" }
        ],
        telphone: [
          { required: true, message: "请输入11位手机号", trigger: "change" },
          { min: 11, max: 11, message: "请输入11位手机号", trigger: "blur" },
          { validator: checkTel, trigger: "blur" }
        ]
      },
      isEdit: false
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      queryChildren({
        id: this.$store.state.user.info.id
      }).then(res => {
        if (res.code == 0) {
          this.tableData = res.result || [];
        }
      });
    },
    userAdd() {
      this.$refs.form.validate(valid => {
        if (valid) {
          let req = userAdd;
          if (this.isEdit) req = userEdit;
          req(this.form).then(res => {
            if (res.code == 200) {
              this.$message.success(res.message);
              this.getData();
              this.addModal = false;
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    add() {
      this.isEdit = false;
      this.form = {
        parentId: this.$store.state.user.info.id,
        userType: 2
      };
      this.addModal = true;
    },
    edit(item) {
      this.isEdit = true;
      this.form = item;
      this.addModal = true;
    },
    del(item) {
      userDelete({ id: item.id }).then(res => {
        if (res.code == 200) {
          this.$message.success(res.message);
          this.getData();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    resetPassword(item) {
      resetPassword({ id: item.id }).then(res => {
        if (res.code == 200) {
          this.$message.success(res.message);
          this.getData();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    frozen(item) {
      frozen({ id: item.id, status: item.userStatus == 1 ? 0 : 1 }).then(
        res => {
          if (res.code == 200) {
            this.$message.success(res.message);
            this.getData();
          } else {
            this.$message.error(res.message);
          }
        }
      );
    },
    changeED(item) {
      this.$prompt("请输入授信额度", "修改授信额度", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^\d+(\.\d+)?$/,
        inputPlaceholder: item.beforehandLimit,
        inputErrorMessage: "必须输入数字"
      })
        .then(({ value }) => {
          this.beforehandLimit(item, value);
        })
        .catch(() => {});
    },
    beforehandLimit(item, num) {
      beforehandLimit({
        id: item.id,
        beforehandLimit: num
      }).then(res => {
        if (res.code == 200) {
          this.$message.success(res.message);
          this.getData();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleSizeChange(e) {
      this.query.pageSize = e;
      this.getData();
    },
    handleCurrentChange(e) {
      this.query.page = e;
      this.getData();
    }
  }
};
</script>

<style lang="less" scoped>

</style>
